import { createAdminClient, createClient } from "@sdk/core";

import { getAccessToken, getTenantId } from "@shared/lib/auth";

const API_BASE = import.meta.env?.VITE_API_BASE_URL || "/";
const REFRESH_PATH = import.meta.env?.VITE_AUTH_REFRESH_PATH || "/auth/refresh";

export const adminClient = createAdminClient(
  createClient({
    baseUrl: API_BASE,
    getToken: getAccessToken,
    getTenantId,
    refreshPath: REFRESH_PATH,
  }),
);
